import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-searchIcon",
  "use": "icon-searchIcon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-searchIcon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.75 7.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM7.5 2.25a5.25 5.25 0 1 0 2.537 9.848l1.84 1.84a.75.75 0 0 0 1.061-1.06l-1.696-1.696A5.25 5.25 0 0 0 7.5 2.25Z\" fill=\"#7F8596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol